import { IDichVuThanhToan } from "../../model/respone/dich-vu/IDichVuThanhToan";
import { apiClient } from "../apiClient";

export const DICH_VU_THANH_TOAN_ENDPOINT = "dich-vu-thanh-toan";
export const dichVuThanhToanApi = {
  SelectAll: () => apiClient.get(`${DICH_VU_THANH_TOAN_ENDPOINT}`),
  Insert: (payload: IDichVuThanhToan) =>
    apiClient.post(`${DICH_VU_THANH_TOAN_ENDPOINT}`, payload),
  Update: (payload: IDichVuThanhToan) =>
    apiClient.put(`${DICH_VU_THANH_TOAN_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${DICH_VU_THANH_TOAN_ENDPOINT}/${id}`),
};
